/* global Visualforce */
export function remoteAction(...args) {
    const allArgs = Array.from(args);
    return new Promise(
        (resolve, reject) => {
            const callback = (result, event) => {
                if (event.status) {
                    resolve(result);
                } else {
                    reject(event);
                }
            };
            allArgs.push(callback);
            allArgs.push({
                escape: false,
                timeout: 600000,
            });
            Visualforce.remoting.Manager.invokeAction.apply(Visualforce.remoting.Manager, allArgs);
        });
}

export function getUrlVars() {
    const vars = [];
    let max = 0;
    let hash = '';
    let array = '';
    const url = window.location.search;

    // ?を取り除くため、1から始める。複数のクエリ文字列に対応するため、&で区切る
    hash = url.slice(1).split('&');
    max = hash.length;
    for (let i = 0; i < max; i += 1) {
        array = hash[i].split('=');
        vars.push(array[0]);
        vars[array[0]] = array[1];
    }

    return vars;
}

export function getCookies() {
    const result = {};
    const cookies = document.cookie;
    if (cookies !== '') {
        const cookieArray = cookies.split(';');
        for (let i = 0; i < cookieArray.length; i += 1) {
            const cookie = cookieArray[i].split('=');
            result[cookie[0].trim()] = decodeURIComponent(cookie[1]);
        }
    }
    return result;
}

export function delCookie(pName) {
    document.cookie = `${pName}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export function createGroupedArray(arr, chunkSize) {
    let groups = [], i;
    for (i = 0; i < arr.length; i += chunkSize) {
        groups.push(arr.slice(i, i + chunkSize));
    }
    return groups;
}
